import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { SearchRecipesState } from '../models/search.model';
import * as SELECTORS from '../selectors/search.selector';

@Injectable({
  providedIn: 'root',
})
export class SearchRecipesFacadeService extends FacadeService {
  constructor(public override store: Store<SearchRecipesState>) {
    super(store);
  }

  // OBSERVABLES
  panelExpanded$ = this.storeSelect(SELECTORS.getPanelExpansion);

  recipeTypes$ = this.storeSelect(SELECTORS.getRecipeTypes);

  recipeCodes$ = this.storeSelect(SELECTORS.getRecipeCodes);

  recipeCodesFiltered$ = this.storeSelect(SELECTORS.getRecipeCodesFiltered);

  schemas$ = this.storeSelect(SELECTORS.getSchemas);

  selectedRecipeType$ = this.storeSelect(SELECTORS.getSelectedRecipeType);

  selectedRecipeName$ = this.storeSelect(SELECTORS.getSelectedRecipeName);

  deleted$ = this.storeSelect(SELECTORS.getDeleted);

  active$ = this.storeSelect(SELECTORS.getActive);

  selectedStartDate$ = this.storeSelect(SELECTORS.getStartDate);

  selectedStartDateString$ = this.storeSelect(SELECTORS.getStartDateString);

  showStartDateClearButton$ = this.storeSelect(SELECTORS.showStartDateClearButton);

  selectedEndDate$ = this.storeSelect(SELECTORS.getEndDate);

  selectedEndDateString$ = this.storeSelect(SELECTORS.getEndDateString);

  showEndDateClearButton$ = this.storeSelect(SELECTORS.showEndDateClearButton);

  sideNav$ = this.storeSelect(SELECTORS.getSideNav);

  gridData$ = this.storeSelect(SELECTORS.getGridData);

  // OBSERVABLES VALUES

  get panelExpanded() {
    return this.storeSnapshot(this.panelExpanded$);
  }

  get deleted() {
    return this.storeSnapshot(this.deleted$);
  }

  get active() {
    return this.storeSnapshot(this.active$);
  }

  get selectedStartDate() {
    return this.storeSnapshot(this.selectedStartDate$);
  }

  get selectedStartDateString() {
    return this.storeSnapshot(this.selectedStartDateString$);
  }

  get selectedEndDate() {
    return this.storeSnapshot(this.selectedEndDate$);
  }

  get selectedEndDateString() {
    return this.storeSnapshot(this.selectedEndDateString$);
  }

  get selectedRecipeType() {
    return this.storeSnapshot(this.selectedRecipeType$);
  }

  get selectedRecipeName() {
    return this.storeSnapshot(this.selectedRecipeName$);
  }

  get schemas() {
    return this.storeSnapshot(this.schemas$);
  }

  get recipeTypes() {
    return this.storeSnapshot(this.recipeTypes$);
  }

  get recipeCodes() {
    return this.storeSnapshot(this.recipeCodes$);
  }

  get gridData() {
    return this.storeSnapshot(this.gridData$);
  }
}
